<template>
  <!-- 由我分配 -->
  <div class="public-sea-clue-assign">
    <el-form
      ref="formRef"
      :model="formData"
      label-width="120px"
      style="padding-top: 20px;"
    >
      <!-- 跟进人 -->
      <el-form-item
        label="跟进人"
        prop="follower"
        :rules="[
          { required: true, message: '请选择跟进人', trigger: 'change' }
        ]"
      >
        <el-select
          v-model="formData.follower"
          placeholder="请选择"
          filterable
          size="small"
          class="form-select"
        >
          <el-option label="杨一一" value="yangyiyi"></el-option>
          <el-option label="杨姗姗" value="yangshanshan"></el-option>
          <el-option label="李某某" value="limoumou"></el-option>
          <el-option label="王某某" value="wangmoumou"></el-option>
        </el-select>
      </el-form-item> 
      <!-- 开始阶段 -->
      <el-form-item label="开始阶段" prop="beginStage">
        <el-select
          v-model="formData.beginStage"
          placeholder="请选择"
          disabled
          size="small"
          class="form-select"
        >
          <el-option label="信息采集" value="S020"></el-option>
        </el-select>
      </el-form-item> 
    </el-form>
  </div>
</template>
 
<script>
  export default {
    name: 'PublicSeaClueAssign',
    data() {
      return {
        formData: {
          follower: '', // 跟进人
          beginStage: 'S020' // 开始阶段
        },
        submitting: false // 防止重复提交
      }
    },
    methods: {
      async submitHandle() {
        // 防止重复提交
        if (this.submitting) {
          return false
        }

        let isFinish = false
        
        try {
          // 表单验证
          const valid = await this.$refs.formRef.validate()
          
          if (!valid) {
            return false
          }

          // 开始提交
          this.submitting = true

          // 构建请求参数
          const params = {
            clueId: this.currentClueInfo.id || this.currentClueInfo.doctorId, // 线索ID
            follower: this.formData.follower, // 跟进人
            beginStage: this.formData.beginStage // 开始阶段
          }

          // 模拟 API 调用（待替换）
          isFinish = await new Promise((resolve) => {
            setTimeout(() => {
              this.$message.success('分配成功')
              resolve(true)
            }, 1000)
          })
          return isFinish
        } catch (error) {
          console.error('由我分配提交失败：', error)
          isFinish = false
          return false
        } finally {
          // 重置提交状态
          this.submitting = false
        }
      }
    },
    props: {
      currentClueInfo: {
        type: Object,
        default: () => ({})
      }
    }
  }
 
</script>

<style scoped lang='less'>

</style>